import React from 'react';

export default function EstimateSelector(props) {
    return (
        <div className="form-line">
            <div className="label ui5-txt-not-important">{props.label}</div>
            <div className="element">
                {props.items.map((obj, key)=>{
                    const classes = Classes("ui5-pill-26", "m-r-5", {
                        selected: props.estimate === obj.value
                    });
                    return <div key={key} className={classes} onClick={()=>{props.onSelectorItemClick(obj.value)}}>{obj.label}</div>
                })}
            </div>
        </div>
    )
}